// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Back',
    title: 'Roles',
    create: 'Create',
    search_by_name: 'Search by Name',
    name: 'Name',
    claims: 'Claims',
}
